var exports = {
  "vK": "ChannelFollowModal.module__banner___Vms4ak",
  "Wp": "ChannelFollowModal.module__patternImage___Vms4ak",
  "JE": "ChannelFollowModal.module__bannerRow___Vms4ak",
  "QE": "ChannelFollowModal.module__sourceGuildIcon___Vms4ak",
  "AQ": "ChannelFollowModal.module__sourceChip___Vms4ak",
  "fS": "ChannelFollowModal.module__sourceChipIcon___Vms4ak",
  "jl": "ChannelFollowModal.module__sourceChipName___Vms4ak",
  "Qs": "ChannelFollowModal.module__content___Vms4ak",
  "Lv": "ChannelFollowModal.module__intro___Vms4ak",
  "DD": "ChannelFollowModal.module__title___Vms4ak",
  "h_": "ChannelFollowModal.module__description___Vms4ak",
  "aK": "ChannelFollowModal.module__hint___Vms4ak",
  "p$": "ChannelFollowModal.module__emptyState___Vms4ak",
  "By": "ChannelFollowModal.module__guildOption___Vms4ak",
  "XN": "ChannelFollowModal.module__guildAvatar___Vms4ak",
  "oM": "ChannelFollowModal.module__guildAvatarPlaceholder___Vms4ak",
  "ed": "ChannelFollowModal.module__optionLabel___Vms4ak",
  "TN": "ChannelFollowModal.module__channelOption___Vms4ak",
  "p": "ChannelFollowModal.module__channelIcon___Vms4ak",
  "yb": "ChannelFollowModal.module__categoryName___Vms4ak",
};

module.exports = exports;
